import { FormProvider } from "react-hook-form";
import { Input } from "@/components/ui/form";
import { Button } from "@/components/ui/button";

export const ResetForm = ({ methods, mutation, onSubmit }) => {
    return (
        <FormProvider {...methods}>
            <form
                onSubmit={methods.handleSubmit(onSubmit)}
                className="grid gap-x-8 gap-y-6"
            >
                <div className="col-span-full">
                    <Input
                        name="email"
                        label="Email address"
                        placeholder="Email"
                    />
                </div>
                <div className="col-span-full">
                    <Button
                        type="submit"
                        id="submitResetPassword"
                        variant="primary"
                        className="w-full"
                        disabled={mutation.isPending}
                    >
                        {mutation.isPending
                            ? "Sending email..."
                            : "Reset Password"}
                    </Button>
                </div>
            </form>
        </FormProvider>
    );
};
